import { createStructuredSelector } from 'reselect'
import { connect } from 'react-redux'
import {
  getAlgoliaDataHitsResults,
  getAlgoliaDataQueryId,
  getAlgoliaSearchIndice,
} from 'selectors/algolia2/data'
import { getAlgoliaUserToken } from 'selectors/user/cookie'
import { getIsMobileScreenWidth, getScreenIsReady } from 'selectors/screen'
import { getUserID } from 'selectors/user/session'
import { SAArtwork } from 'types/Artwork'
import { getSearchQuery } from 'apps/public/browse/selectors/seoContent'

import { getTitle } from '../selectors/app'

const mapStateToProps = createStructuredSelector({
  algoliaIndice: getAlgoliaSearchIndice,
  algoliaQueryId: getAlgoliaDataQueryId,
  algoliaUserToken: getAlgoliaUserToken,
  artworks: getAlgoliaDataHitsResults,
  isMobileScreen: getIsMobileScreenWidth,
  isScreenReady: getScreenIsReady,
  userID: getUserID,
  title: getTitle,
  searchQuery: getSearchQuery,
})

export type ConnectorProps = {
  algoliaIndice: string
  algoliaQueryId: string
  algoliaUserToken: string
  artworks: ReadonlyArray<SAArtwork>
  isMobileScreen: boolean
  isScreenReady: boolean
  userID: number
  title: string
  searchQuery: string | null
}

export default connect(mapStateToProps)
